const SelectMode = ({ modes, selectedMode, setSelectedMode }) => {
    return (
        <select
        id='mode-select'
        className='mode-select'
        value={selectedMode}
        onChange={(e) => setSelectedMode(e.target.value)}
        >
            {modes.map((mode) => (
                <option
                    key={mode[1]}
                    value={mode[0]}
                >
                    {mode[1]}
                </option>
            ))}
        </select>
    );
};

export default SelectMode;